/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable dot-location */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import {
    Col,
    Container,
    Row,
    Form,
    CardBody,
    Card,
    Label,
    Input,
    Button,
    TabContent,
    TabPane,
    Nav,
    NavLink,
    NavItem,
    CardHeader,
} from "reactstrap";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import withRouter from "Components/Common/withRouter";
import { useFormik } from "formik";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import * as Yup from "yup";
import "../../../assets/scss/pages/_onBoarding.scss"






// Register the plugins

const TellUsShop = (props: any) => {
    document.title = "Tell Us About Your Shop | BuyPass";
    const selectUser = createSelector(
        (state: any) => state.User,
        (user) => user?.user
    );

    const user = useSelector(selectUser);

    useEffect(() => {
        if (!user) return;
        formik.setFieldValue("email", user?.email || "");
        formik.setFieldValue("preferred_username", user?.preferred_username || "");
    }, [user]);

    const validationSchema = Yup.object({
        // streetAddress: Yup.string()
        //   .required("Address details are required")
        //   .min(5, "Address must be at least 5 characters long"),
        // state: Yup.string()
        //   .required("Region/City/District is required"),
    });

    // Initialize Formik
    const formik = useFormik({
        initialValues: {
            email: "",
            preferred_username: "",
            password: "Abcd123456@",
        },
        validationSchema,
        onSubmit: (values) => {
            // const updatedSeller = {
            //     ...user,
            // };
        },
    });
    return (
        <div className="onBoardingMain">
            <div className="mt-2 mb-2">
                <h2 className="shop-title">Tell Us About Your Shop</h2>
                <h5 className="shop-details-description">
                    Enter your shop details to create your profile and <br />verify your business.
                </h5>
            </div >
            <Form>
                <Col sm={12} md={12} lg={12}>
                    <div className="formContainer mt-4">
                        <Label htmlFor="email" className="form-label" >
                            Email
                        </Label>
                        <Input
                            disabled
                            type="email"
                            name="email"
                            className={`form-control ${formik.touched.email && formik.errors.email ? "is-invalid" : ""
                                }`}
                            id="email"
                            placeholder="Email Address"
                            onChange={(e) => {
                                formik.handleChange(e);
                                // handleFieldChange("email", e);
                            }}
                            onBlur={formik.handleBlur}
                            value={formik.values.email}
                            data-testing-id="emailInput_TellUsShop"
                        />
                        {formik.touched.email && formik.errors.email && (
                            <div className="invalid-feedback">{formik.errors.email}</div>
                        )}
                    </div>


                    <div className="formContainer mt-4">
                        <Label htmlFor="phoneNumber" className="form-label mt-10">
                            Phone Number
                        </Label>
                        <Input
                            disabled
                            type="tel"
                            name="phoneNumber"
                            className={`form-control ${formik.touched.preferred_username && formik.errors.preferred_username ? "is-invalid" : ""
                                }`}
                            id="preferredUsername"
                            placeholder="Phone Number"
                            onChange={(e) => {
                                formik.handleChange(e);
                                // handleFieldChange("phoneNumber", e);
                            }}
                            onBlur={formik.handleBlur}
                            value={formik.values.preferred_username}
                            data-testing-id="phoneNUmberInput_TellUsShop"
                        />
                        {formik.touched.preferred_username && formik.errors.preferred_username && (
                            <div className="invalid-feedback">{formik.errors.preferred_username}</div>
                        )}

                    </div>

                    <div className="formContainer mt-4">
                        <Label htmlFor="password" className="form-label mt-10">
                            Password
                        </Label>
                        <Input
                            disabled
                            type="password"
                            name="password"
                            className={`form-control ${formik.touched.password && formik.errors.password ? "is-invalid" : ""
                                }`}
                            id="password"
                            placeholder="password"
                            onChange={(e) => {
                                formik.handleChange(e);
                                // handleFieldChange("phoneNumber", e);
                            }}
                            onBlur={formik.handleBlur}
                            value={formik.values.password}
                            data-testing-id="passwordInput_TellUsShop"
                        />
                        {formik.touched.password && formik.errors.password && (
                            <div className="invalid-feedback">{formik.errors.password}</div>
                        )}
                    </div>

                </Col>

            </Form>
        </div>
    );
};

export default withRouter(TellUsShop);
